import { Link } from "react-router-dom";

export default function SubmitCta() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20a%20lone%20desk%20lamp%20over%20a%20dark%20empty%20newsroom%20at%20midnight%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=1600&height=720&seq=heian-submit-cta-bg-2026&orientation=landscape"
          alt="匿名投稿入口示意配图"
          title="黑暗爆料 - 匿名投稿入口"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/78 to-foreground-950/55"></div>

      <div className="relative mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-50/25 px-3 py-1.5 text-xs font-label tracking-[0.15em] text-background-100">
            <i className="ri-lock-line" aria-hidden="true"></i>
            匿名投稿 · 全程脱敏
          </p>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
            你知道的那一部分，可能正是别人缺的那一块。
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
            不需要准备完整的证据，也不用担心身份暴露。把你看到的、听到的、经历过的说清楚，剩下的交给编辑部去核实与整理。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-label font-semibold text-primary-950 transition-colors hover:bg-accent-400 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line text-base" aria-hidden="true"></i>
              前往匿名投稿
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/30 px-6 py-3 text-sm font-label font-medium text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
            >
              了解编辑原则
            </Link>
          </div>

          <p className="mt-6 flex items-center gap-2 text-xs text-background-300">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            投稿内容不会与真实身份关联，编辑部保留与你的安全联络方式。
          </p>
        </div>
      </div>
    </section>
  );
}